<template>
  <div class="shop-the-look__heading-wrapper">
    <h2
      v-if="heading"
      class="text-body-l-medium shop-the-look__heading"
      v-text="heading"
    />

    <div
      v-if="totalLooks > 1"
      class="shop-the-look__buttons splide__arrows splide__arrows--ltr"
    >
      <button
        type="button"
        :disabled="currentLook === 1"
        class="shop-the-look__buttons-prev splide__arrow splide__arrow--prev"
        :aria-label="$string('accessibility.carousel.previous')"
        @click="prevSlide"
      >
        <icon-arrow-left />
      </button>

      <span class="shop-the-look__counter text-body-s-medium">
        {{ currentLook }}  {{ $string('general.shop_the_look.count_separator') }} {{ totalLooks }}
      </span>

      <button
        type="button"
        :disabled="currentLook === totalLooks"
        class="shop-the-look__buttons-next splide__arrow splide__arrow--next"
        :aria-label="$string('accessibility.carousel.next')"
        @click="nextSlide"
      >
        <icon-arrow-right />
      </button>
    </div>
  </div>
</template>

<script>

/**
 * Vue: shop-the-look header (heading-wrapper)
 * -----------------------------------------------------------------------------
 * Heading component for the Shop the Look.
 * @param {String} heading - Heading for the section.
 * @param {Function} nextSlide - Function to go to next slide.
 * @param {Function} prevSlide - Function to go to previous slide.
 * @param {String} class - Class for the component.
 *
 */

import IconArrowLeft from '~icons/directional-navigation/chevron/left.svg'
import IconArrowRight from '~icons/directional-navigation/chevron/right.svg'

export default {
  name: 'HeadingWrapper',
  components: {
    IconArrowLeft,
    IconArrowRight,
  },

  props: {
    heading: {
      type: String,
      default: '',
    },
    nextSlide: {
      type: Function,
      required: true,
    },
    prevSlide: {
      type: Function,
      required: true,
    },
    totalLooks: {
      type: Number,
      default: 0,
    },
    currentLook: {
      type: Number,
      default: 0,
    },
  },

}
</script>
